import React from 'react';
import { NavLink } from 'react-router-dom';
import { usePermissions, Permissions } from '../hooks/usePermissions';

interface ProtectedNavLinkProps {
  to: string;
  children: React.ReactNode;
  permission: keyof Permissions;
  className?: string;
  end?: boolean;
}

const ProtectedNavLink: React.FC<ProtectedNavLinkProps> = ({
  to,
  children,
  permission,
  className,
  end = false,
}) => {
  const permissions = usePermissions();

  if (!permissions[permission]) {
    return null;
  }

  return (
    <NavLink
      to={to}
      className={className}
      end={end}
    >
      {children}
    </NavLink>
  );
};

export default ProtectedNavLink;
